/* tslint:disable */
/* eslint-disable */
/**
 * Abekus Open API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



export interface DashboardPersonaBody {
    'goal'?: DashboardPersonaBodyGoalEnum;
    'persona'?: DashboardPersonaBodyPersonaEnum;
}

export const DashboardPersonaBodyGoalEnum = {
    BuildSkills: 'BuildSkills',
    GetJob: 'GetJob',
    GrowCareer: 'GrowCareer',
} as const;

export type DashboardPersonaBodyGoalEnum = typeof DashboardPersonaBodyGoalEnum[keyof typeof DashboardPersonaBodyGoalEnum];
export const DashboardPersonaBodyPersonaEnum = {
    Learner: 'Learner',
    JobFinder: 'JobFinder',
    Experienced: 'Experienced',
} as const;

export type DashboardPersonaBodyPersonaEnum = typeof DashboardPersonaBodyPersonaEnum[keyof typeof DashboardPersonaBodyPersonaEnum];


